/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Various random small UI widget behaviors
//
// These should all automatically attach based on an appropriate data- attribute
//
// These should implement a jQuery plugin for ease of attachment

namespace('Slzr.UI', function(exports, top) {
  const $ = Slzr.jQuery;

  // Filter selection widgets
  const Cls = (exports.FilterSelector = class FilterSelector {
    static initClass() {
      this.prototype.default_options = {
        element: null, // Dropdown element which gets selected
        container: null, // container of the selected items
        template: null
      };
       // template of the selected item bubbles
    }

    constructor(options) {
      this.options = $.extend({}, this.default_options, options);
      this.element = $(this.options.element);
      this.container = $(this.options.container);

      this.template = JST[this.options.template] || JST[`${LOCALIST_SETTINGS.jst_namespace}/filter_item`] || JST['filter_item'];
      // Get other state out of data tags if available
      const template_name = this.element.data('tag-template') || this.options.template || 'filter_item';
      this.template = JST[`${LOCALIST_SETTINGS.jst_namespace}/${template_name}`] || JST[template_name];

      this.param = this.element.data('tag-param') || this.options.param;
      this.param_index = this.element.data('tag-param-index') || this.options.param_index;
      this.param_name = this.element.data('tag-param-name') || this.options.param_name;
      this.container = this.element.data('tag-container') ? $(`#${  this.element.data('tag-container')}`) : this.options.container;
      this.selected_prefix = this.element.data('tag-selected-prefix') || 'tag';

      // Attach event handlers
      this.element.on('change.FilterSelector', () => this.selectionChanged());

      // Container remove
      const me = this;
      this.container.on('click.FilterSelector', '[data-action="remove-tag"]', function() {
        const tag_id = $(this).data('tag-id');
        const tag_context = $(this).data('tag-context');
        const prefix = $(this).data('tag-prefix') || 'tag';
        $(`#${prefix}_${tag_id}`).remove();
        me.element.trigger('slzr:filter:remove', {context: tag_context, tag_id});
        return false;
      });
    }

    selectionChanged() {
      const tag_id = this.element.val();
      const selected = this.element.find('option:selected');
      const tag_name = selected.data('tag-name') || selected.html().replace(/&nbsp;/g, ' ').replace(/^\s+/, '');

      if (tag_id && ($(`#tag_${tag_id}`).length === 0)) {
        const new_el = this.template({tag_id, tag_name, attribute: this.param_index, param: this.param, param_name: this.param_name, selected_prefix: this.selected_prefix});
        this.container.append(new_el);
        this.element.val(null);
        this.element.trigger('slzr:filter:add', {context: this.param_index, tag_id});
      }

      // Stop actions
      return false;
    }
  });
  Cls.initClass();

  // Attach it to the jQuery object
  return $.fn.extend({
    filterSelector(options) {
      const my_options = options;

      this.each(function() {
        const filter_options =
          {element: this};
          // container: my_options.container
          // template: my_options.template

        return new exports.FilterSelector(filter_options);
      });

      // Return this, allowing chaining
      return this;
    }
  });
});

// Attach filter selector controls
Slzr.jQuery($ => $('[data-action="add-tag"]').filterSelector());

namespace('Slzr.Message', function(exports, top) {
  const $ = Slzr.jQuery;

  return exports.textChanged = function(el) {
    el = $(el);
    const form = $(el).closest('form');
    const submit = form.find('input[type="submit"]');

    return submit.prop('disabled', el.val().isBlank());
  };
});
